export default __webpack_public_path__ + "static/miradouro-lisboa-1e5a27914e437b01cf18fc2dc5ec2d27.jpg";